let froalaLicenseKey = '';

export const setFroalaLicenseKey = (key: string): void => {
  froalaLicenseKey = key;
};

export const getFroalaLicenseKey = (): string => froalaLicenseKey;
